import styled from 'styled-components'
import { colors } from '../../theme'

export const PrincipalDiv = styled.div`
  margin-top: 30px;
  background-color: ${colors.surface};
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  padding: 20px;

  h3 {
    margin-bottom: 20px;
  }
  h4 {
    font-size: 19px;
  }
`

export const Acessos = styled.div`
  margin-top: 30px;
  position: relative;
  padding: 5px 30px 5px 0px;
  width: 100%;
  text-align: left;

  h4 {
    margin-bottom: 20px;
  }

  label {
    position: absolute;
    top: -4px;
    left: 15px;
    background: ${colors.surface};
    color: ${colors.grey500};
    padding: 0 3px;
    font-size: 12px;
  }

  select {
    width: 320px;
    height: 23px;
    border: 1px solid ${colors.grey300};
    border-radius: 12px;
    font-size: 14px;
    padding: 20px 20px 20px 20px;
  }
  option {
    font-size: 14px;
    font-weight: 600;
  }
`

export const DivForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  align-items: center;
`

export const DivAccess = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  width: 25%;
`

export const SpanAdm = styled.span`
  margin: 10px 0 25px 0;
  display: flex;
  font-size: 14px;
  b {
    margin-top: 2px;
  }
`

export const DivAdm = styled.div`
  margin-top: 30px;
  width: 25%;
`
export const Byes = styled.b`
  margin-right: 35px;
  margin-top: 2px;
`
export const B = styled.b`
  margin-left: 25px;
  font-weight: 600;
  font-size: 14px;
`

export const FormLogin = styled.div`
  position: relative;
`

export const LabelLSwitch = styled.label`
  position: absolute;
  top: -13px;
  background: ${colors.surface};
  color: ${colors.grey500};
  left: 0px;
  padding: 0 3px;
  font-size: 12px;
`

export const LabelLogin = styled.label`
  position: absolute;
  top: -9px;
  background: ${colors.surface};
  color: ${colors.grey500};
  left: 15px;
  padding: 0 3px;
  font-size: 12px;
`
export const LabelCheck = styled.label`
  background: ${colors.surface};
  color: ${colors.grey500};
  font-size: 12px;
`

export const SpanCheck = styled.span`
  display: flex;
  gap: 5px;
`

export const InputLogin = styled.input`
  /* Transparente de proposito: o rotulo flutuante recorta a borda deste campo, e
     esse recorte so funciona se campo e container tiverem a MESMA cor. Com o campo
     preenchido, o rotulo atravessa a fronteira e vira uma caixa visivel. Campos SEM
     rotulo flutuante (busca, filtros) seguem preenchidos pela base do GlobalStyle. */
  background-color: transparent;
  width: 320px;
  height: 23px;
  border: 1px solid ${colors.grey300};
  border-radius: 12px;
  font-size: 14px;
  padding: 20px 20px 20px 20px;
`

export const BtnSave = styled.button`
  margin-top: 30px;
  cursor: pointer;
  background-color: ${colors.accentBg};
  color: ${colors.white};
  border: none;
  width: 240px;
  height: 40px;
  border-radius: 16px;
`
